import { render, staticRenderFns } from "./initiate_certification_dialog.vue?vue&type=template&id=57bf65cb&scoped=true"
import script from "./initiate_certification_dialog.vue?vue&type=script&lang=js"
export * from "./initiate_certification_dialog.vue?vue&type=script&lang=js"
import style0 from "./initiate_certification_dialog.vue?vue&type=style&index=0&id=57bf65cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf65cb",
  null
  
)

export default component.exports